export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/step-arrow.a7fe8d3b-1af177.svg";